import { types } from 'mobx-state-tree';

export default types.model('ItemListing', {
  alias: types.string,
  price: types.union(types.number, types.string),
  title: types.maybeNull(types.string),
  image: types.string,
  mode: types.string,
  status: types.maybeNull(types.string),
  checkout_url: types.string,
  quantity: types.number,
});
